export default {
  // ── Common ──
  'next': 'Next',
  'back': 'Back',
  'apply': 'Apply',
  'collapse': 'Collapse',
  'expand': 'View Details',
  'close': 'Close',
  'search': 'Search',
  'loading': 'Loading...',
  'noResults': 'No results found',
  'noResultsHint': 'Try searching in Korean or English',

  // ── Intro ──
  'intro.badge': 'Astronomy-Based Precision Analysis',
  'intro.title': 'The time on your clock\nmay not reflect\nyour true destiny.',
  'intro.subtitle1': 'Based on astronomical data,',
  'intro.subtitle2': 'we calculate your true birth chart with ',
  'intro.highlight': 'zero margin of error.',
  'intro.subtitle3': '',
  'intro.cta': 'Find My True Fortune',
  'intro.free': 'Free · No sign-up · 1 minute',
  'intro.feat1': 'Longitude-Based True Solar Time',
  'intro.feat2': 'Historical Daylight Saving Included',
  'intro.feat3': 'Equation of Time Applied',

  // ── BirthDate ──
  'date.step': 'Step 1 · Date of Birth',
  'date.title': 'When were you born?',
  'date.female': 'Female',
  'date.male': 'Male',
  'date.solar': 'Solar',
  'date.lunar': 'Lunar',
  'date.lunarLeap': 'Lunar (Leap)',
  'date.year': 'Year',
  'date.month': 'Month',
  'date.day': 'Day',
  'date.yearUnit': '',
  'date.monthUnit': '',
  'date.dayUnit': '',
  'date.preview.solar': 'Solar Calendar',
  'date.preview.lunar': 'Lunar Calendar',
  'date.preview.lunarLeap': 'Lunar Leap Month',

  // ── BirthTime ──
  'time.step': 'Step 2 · Time of Birth',
  'time.title': 'Do you know your\nexact birth time?',
  'time.hint': 'The more precise (minute-level) the birth time from hospital records, the more accurate your reading. Without the time, only 3 of 4 pillars can be read.',
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.hourUnit': ':00',
  'time.minuteUnit': 'min',
  'time.labelAmpm': 'AM/PM',
  'time.labelHour': 'Hour',
  'time.labelMinute': 'Minute',
  'time.unknown': "I don't know the time",
  'time.unknownModal.title': "Birth time unknown",
  'time.unknownModal.body': "Without the time, only 3 pillars (6 characters) out of 4 can be shown. You can always come back and enter the time later!",
  'time.unknownModal.confirm': 'Continue anyway',
  'time.midnight': 'Midnight (00:00)',

  // ── BirthLocation ──
  'location.step': 'Step 3 · Place of Birth',
  'location.title': 'Where were\nyou born?',
  'location.hint': 'To calculate the precise cosmic time, we need the longitude & latitude of your birthplace. You can also search by hospital name.',
  'location.tabKorea': 'South Korea',
  'location.tabOverseas': 'Overseas',
  'location.placeholderKorea': 'Search city, district, hospital...',
  'location.placeholderOverseas': 'Search city or English name...',
  'location.popular.korea': 'Popular cities',
  'location.popular.overseas': 'Popular overseas cities',
  'location.overseas.hint': 'You can search in English: Tokyo, Shanghai, New York, etc.',
  'location.fallback': 'Using local data',
  'location.longitude': 'Longitude',
  'location.latitude': 'Latitude',
  'location.next': 'Next',
  'location.next.disabled': 'Please select a location',

  // ── Loading ──
  'loading.analyzing': 'Analyzing',
  'loading.step1': 'Analyzing longitude of {{location}}...',
  'loading.step2': 'Checking {{year}} standard time records...',
  'loading.step3': 'Checking daylight saving status for {{year}}...',
  'loading.step4': 'Calculating equation of time (seasonal)...',
  'loading.step5': 'Applying true solar time correction...',
  'loading.step6': 'Cross-checking solar term boundaries...',
  'loading.step7': 'Correction complete with true cosmic time! ✓',

  // ── Receipt ──
  'receipt.corrected': 'Corrected',
  'receipt.title': "We found your\ntrue birth time!",
  'receipt.header': 'Birth Time Correction Report',
  'receipt.birthYear': ' Birth Year',
  'receipt.inputTime': 'Clock Time (Input)',
  'receipt.longitudeCorr': 'Longitude Correction',
  'receipt.eotCorr': 'Equation of Time (Orbital)',
  'receipt.eotNote': 'Seasonal solar offset applied',
  'receipt.dstCorr': 'Daylight Saving Correction',
  'receipt.trueTime': 'True Solar Time',
  'receipt.totalCorr': 'Total Correction',
  'receipt.east': 'east',
  'receipt.west': 'west',
  'receipt.east.note': 'East of standard meridian',
  'receipt.west.note': 'West of standard meridian',
  'receipt.branchChanged.title': '⚠️ Your Hour Pillar has changed!',
  'receipt.branchChanged.body1': 'What would have been ',
  'receipt.branchChanged.body2': ' changed to ',
  'receipt.branchChanged.body3': ' after precision correction!',
  'receipt.cta': 'View My Four Pillars',
  'receipt.dst.note': 'Born during DST (−60 min correction)',

  // ── SajuResult ──
  'result.badge': 'Precision Correction Complete',
  'result.title': 'These are your\n8 Destiny Characters.',
  'result.unknownTime': 'Without birth time, showing 3 pillars (6 characters) excluding the Hour Pillar.',
  'result.lunarConv.title': 'Lunar → Solar Calendar Conversion',
  'result.lunarConv.body1': 'Lunar ',
  'result.lunarConv.body2': ' → Solar ',
  'result.lunarConv.body3': ' (auto-converted for calculation)',
  'result.lunarLeap': 'Lunar Leap ',
  'result.calc.title': 'Calculation Basis',
  'result.calc.longitude': 'Birthplace Longitude',
  'result.calc.eot': 'Equation of Time',
  'result.calc.trueTime': 'Applied True Solar Time',
  'result.dayInterp.label': 'Day Pillar Interpretation',
  'result.dayInterp.personality': 'Personality Traits',
  'result.dayInterp.strengths': 'Strengths',
  'result.dayInterp.weaknesses': 'Cautions',
  'result.dayInterp.advice': 'Advice for You',
  'result.tab.fortune': 'Fortune',
  'result.tab.analysis': 'Analysis',
  'result.tab.calendar': 'Calendar',
  'result.expert': 'Expert Settings',
  'result.expert.title': 'Expert Settings',
  'result.expert.yajasi.title': 'Zi Hour (子時) Standard',
  'result.expert.yajasi.desc': 'If born between 11 PM and midnight, this setting may affect your chart. Different scholars have different views on this.',
  'result.expert.yajasi.ya': 'Ya-Jasi (Today\'s Zi)',
  'result.expert.yajasi.ya.desc': '11 PM = today',
  'result.expert.yajasi.jo': 'Jo-Jasi (Tomorrow\'s Zi)',
  'result.expert.yajasi.jo.desc': '11 PM = tomorrow',
  'result.yearlyReport.title': '2026 Annual Fortune Report',
  'result.yearlyReport.subtitle': 'Precision destiny analysis in classified format →',
  'result.yearlyReport.classified': 'CLASSIFIED',
  'result.restart': 'Calculate Another Chart',
  'result.timeUnknownHour': 'Time Unknown',
  'result.stemLabel': 'Heavenly Stem',
  'result.branchLabel': 'Earthly Branch',

  // ── Ohaeng ──
  'ohaeng.title': 'Five Elements (五行) Analysis',
  'ohaeng.subtitle': 'Precision calculation with seasonal month weighting',
  'ohaeng.dominant': 'Strongest Element',
  'ohaeng.dominant.full': ' energy dominates your chart!',
  'ohaeng.lacking': 'Element Needing Balance',
  'ohaeng.flow': 'Five Elements Cycle',
  'ohaeng.flow.label': 'Five Elements:',
  'ohaeng.flow.desc': 'Wood → Fire → Earth → Metal → Water → Wood (Generation) / Wood controls Earth · Fire controls Metal · Earth controls Water · Metal controls Wood · Water controls Fire (Control)',
  'ohaeng.wood': 'Wood (木)',
  'ohaeng.fire': 'Fire (火)',
  'ohaeng.earth': 'Earth (土)',
  'ohaeng.metal': 'Metal (金)',
  'ohaeng.water': 'Water (水)',
  'ohaeng.personality.wood': 'Strong growth instinct — loves challenges and new beginnings. Leadership and creativity overflow.',
  'ohaeng.personality.fire': 'Burning passion and expressiveness! Charismatic energy that lights up the room.',
  'ohaeng.personality.earth': 'Reliable and trustworthy energy. Consistency and dependability are your greatest strengths.',
  'ohaeng.personality.metal': 'Sharp judgment and decisiveness. Precise and logical thinker.',
  'ohaeng.personality.water': 'Deep wisdom and flexibility. Outstanding adaptability to any situation.',
  'ohaeng.lacking.wood': 'Cultivating more perseverance and patience would benefit you greatly.',
  'ohaeng.lacking.fire': 'Passion may be lacking. Light the fire toward your goals.',
  'ohaeng.lacking.earth': 'You need more stability right now. Try building daily routines.',
  'ohaeng.lacking.metal': 'Decisiveness is needed. Make clearer choices and follow through.',
  'ohaeng.lacking.water': 'Developing flexibility and wisdom will enrich your life.',

  // ── Daeun ──
  'daeun.title': 'Major Luck Cycle (大運)',
  'daeun.desc': 'A major energy cycle that shifts every 10 years. When it changes, so does the direction of your life.',
  'daeun.current': 'Current Cycle',
  'daeun.forward': 'Forward (順行)',
  'daeun.backward': 'Reverse (逆行)',
  'daeun.startAge': ' years after birth',
  'daeun.startAge.months': ' months',
  'daeun.startAge.immediate': 'Starts at birth',
  'daeun.guide.title': 'How to Read',
  'daeun.guide.desc': 'Each block represents 10 years. The upper character (Heavenly Stem) reflects external environment & social flow; the lower (Earthly Branch) reflects inner transformation.',
  'daeun.age.range': '–',
  'daeun.age.unit': ' yrs',
  'daeun.year.unit': '~',

  // ── Sewoon ──
  'sewoon.title.suffix': ' Annual Fortune',
  'sewoon.subtitle': "This year's fortune flow",
  'sewoon.score': 'Annual Fortune Score',
  'sewoon.career': 'Career',
  'sewoon.love': 'Love & Relationships',
  'sewoon.money': 'Finances',
  'sewoon.health': 'Health',
  'sewoon.monthly.title': 'Monthly Fortune',
  'sewoon.monthly.detail': 'Details',
  'sewoon.monthly.collapse': 'Collapse',
  'sewoon.lucky.title': ' Lucky Info',
  'sewoon.lucky.color': 'Lucky Color',
  'sewoon.lucky.number': 'Lucky Number',
  'sewoon.lucky.direction': 'Lucky Direction',
  'sewoon.advice.title': "This Year's Advice",
  'sewoon.level.excellent': 'Excellent',
  'sewoon.level.good': 'Good',
  'sewoon.level.normal': 'Neutral',
  'sewoon.level.challenging': 'Challenging',
  'sewoon.level.difficult': 'Difficult',

  // ── Monthly Fortune ──
  'monthly.title': 'Monthly Fortune',
  'monthly.title.year': '{{year}} Monthly Fortune',
  'monthly.subtitle': 'How your chart interacts with each month',
  'monthly.good': 'Good months',
  'monthly.normal': 'Neutral months',
  'monthly.caution': 'Caution months',
  'monthly.tab.all': 'All',
  'monthly.tab.good': 'Good',
  'monthly.tab.bad': 'Caution',
  'monthly.empty': 'No months match this filter',
  'monthly.score.great': 'Great',
  'monthly.score.good': 'Good',
  'monthly.score.normal': 'Neutral',
  'monthly.score.caution': 'Caution',
  'monthly.score.bad': 'Avoid',
  'monthly.month.suffix': '',

  // ── Sipseong ──
  'sipseong.title': 'Ten Gods (十星) Analysis',
  'sipseong.subtitle': 'How your 8 characters shape your life',
  'sipseong.dominant': 'Dominant God',
  'sipseong.hidden.title': 'Hidden Energy (Hidden Stems)',
  'sipseong.hidden.label': 'Deeply hidden: ',
  'sipseong.tab.career': 'Career',
  'sipseong.tab.love': 'Love',
  'sipseong.tab.wealth': 'Wealth',
  'sipseong.advice.title': 'Message for You',
  'sipseong.category.top': 'Dominant Category Energy',
  'sipseong.detail.title': 'View Each Pillar',
  'sipseong.detail.stem': 'Heavenly Stem',
  'sipseong.detail.branch': 'Earthly Branch',
  'sipseong.detail.jijang': 'Hidden Stems',
  'sipseong.detail.daegan': 'Self (Day Master)',

  // ── Singangyak ──
  'singangyak.title': 'Day Master Strength Analysis',
  'singangyak.subtitle': 'Intensity and balance of your core energy',
  'singangyak.deonnyeong': 'Season Support',
  'singangyak.present': '✓ Yes',
  'singangyak.absent': '✗ No',
  'singangyak.gauge.extremeWeak': 'Very Weak',
  'singangyak.gauge.balanced': 'Balanced',
  'singangyak.gauge.extremeStrong': 'Very Strong',
  'singangyak.gauge.weakSide': 'Weaker',
  'singangyak.gauge.strongSide': 'Stronger',
  'singangyak.detail.title': 'View Score Details',
  'singangyak.detail.deotnyeong': 'Season (得令)',
  'singangyak.detail.deotnyeong.desc': 'Birth month energy',
  'singangyak.detail.deotji': 'Position (得地)',
  'singangyak.detail.deotji.desc': 'Day branch energy',
  'singangyak.detail.deotse': 'Allies (得勢)',
  'singangyak.detail.deotse.desc': 'Support from surrounding characters',
  'singangyak.yongshin.title': 'Key to Your Fortune',
  'singangyak.yongshin.label': 'Beneficial Element (用神): ',
  'singangyak.note': '※ Day Master strength assessment may vary by school of thought. This calculation follows the standard Season/Position/Allies method.',

  // ── ShareCard ──
  'share.button': 'Share Your Saju Reading',
  'share.pillarTitle': 'My Four Pillars',
  'share.dayPillarLabel': 'Day Pillar (日柱) — Your Essence',
  'share.hourPillar': 'Hour',
  'share.kakao': 'KakaoTalk',
  'share.copyLink': 'Copy Link',
  'share.copied': 'Copied!',
  'share.copyText': 'Copy Text',
  'share.more': 'More',
  'share.footer': 'BarunSaju — Precision True Solar Time Calculator',
  'share.appTitle': 'BarunSaju',
  'share.kakaoTitle': 'BarunSaju — My Saju Reading',
  'share.nativeTitle': 'My BarunSaju Result',

  // ── SajuHistory ──
  'history.title': 'Recent Charts',
  'history.empty': 'No charts calculated yet',
  'history.empty.hint': 'Your charts will be saved automatically',
  'history.timeUnknown': 'Time unknown',
};
